import { Box } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type AccordionProps = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export const Accordion = ({ props }: AccordionProps) => {
  return (
    <Box component="ul" sx={{ padding: 0, margin: 0, listStyle: 'none' }} data-testid="accordion">
      <StructuredContentRenderer doc={props.children} />
    </Box>
  );
};
